<template>
    <div class="stretch-layout">
            <title-bar with-search :title="$t('param_label.fans', clubStore.club.followers_count, {count: clubStore.club.followers_count})"
                       v-model="filter.search"/>

			<data-loader :url="`/v1/clubs/${clubStore.club.id}/followers`"
					   :params="params"
					   :filter="filter"
						 auth
					   on-scroll
						 ref="loaderElement"
						 :persist-filter-keys="['search']">

				<template #loading>
					<row>
						<column cols="12" md="6" lg="4" v-for="modelLoader in params.limit" :key="'model-loader-' + modelLoader">
							<div :class="{'divided-grid': $device.isMobile}">
								<profile-preview-skeleton :flat="$device.isMobile" :class="{'mb-0': $device.isMobile}"/>
							</div>
						</column>
					</row>
				</template>

				<template v-slot="{data}">
					<row>
						<column cols="12" md="6" lg="4" v-for="(follower, key) in data" :key="key">
							<div :class="{'divided-grid': $device.isMobile}">
								<profile-preview :model="follower" :to="$web(follower.model_name + 's.show.index', follower._key)" :flat="$device.isMobile" :class="{'mb-0': $device.isMobile}"/>
							</div>
						</column>
					</row>
				</template>

				<template #missingsearch>
					<missing-info :icon="icons.follower" card xs-tile sm-tile class="min-h-200" :text="$t('missing.followers.search', {name: clubStore.club.display_name})"/>
				</template>
				<template #missing>
					<missing-info :icon="icons.follower" card xs-tile sm-tile class="min-h-200"
								  :text="$t('missing.club.followers', {name: clubStore.club.display_name})"/>
				</template>
			</data-loader>
    </div>
</template>

<script setup lang="ts">
import {mdiAccountMultipleOutline} from '@mdi/js';
import {useClubStore} from "../../../store/club";
import {useIndexStore} from "../../../store";

const clubStore = useClubStore();
const indexStore = useIndexStore();
const route = useRoute();
const {t} = useI18n();

const filter = ref({
	// The query to search for a specific follower
	search: route.query.search
});

const icons = {
	follower: mdiAccountMultipleOutline
};

const params = {limit: 21}

const loaderElement = ref(null);

const isFollowing = computed(() => {
	return indexStore.follows.findIndex(follow => follow.type === clubStore.club.model_type && follow.id === clubStore.club.id) > -1;
});

watch(isFollowing, () => {
	if (loaderElement.value) {
		loaderElement.value.reload(1, true, false);
	}
});

useMeta({
	title: clubStore.buildPageTitle(t('view.clubs.follower.index.title', {club: clubStore.club.display_name})),
	description: t('view.clubs.follower.index.description', {club: clubStore.club.display_name}),
	noIndex: true
})
</script>

